import { RootState } from '../store'
import {
  CountDoneActionsForRelatedControlsResponse,
  CountDoneActionsForSecurityControlResponse,
  CountInProgressActionsForSecurityControlResponse,
  CountOtherActionsForRelatedControlsResponse,
  CountOtherActionsForSecurityControlResponse,
} from '../../types/securityControls'
export const selectRisques = (state: RootState) =>
  state.security.SecurityControls
export const selectLoading = (state: RootState) => state.security.loading
export const selectError = (state: RootState) => state.security.error
export const selectSecurityCheckData = (state: RootState) =>
  state.securitycheckFamily.data
export const selectSecurityControl = (state: RootState) =>
  state.security.securityControl
export const selectRelatedAudits = (state: RootState) =>
  state.security.relatedAudits

// Common selectors
export const selectSecurityControlsLoading = (state: RootState) =>
  state.security.loading

export const selectSecurityControlsError = (state: RootState) =>
  state.security.error
export const selectAverageSCScore = (state: RootState) =>
  state.security.averageSCScore
export const selectGlobalAverage = (state: RootState) =>
  state.security.dataAverage
export const selectAverageActionsForRelatedControls = (state: RootState) =>
  state.security.averageActionsData
export const selectAverageCostForRelatedControls = (state: RootState) =>
  state.security.averageCostData
export const selectRelatedControlsActionsCosts = (state: RootState) =>
  state.security.relatedControlsActionsCosts
export const selectLateRateForRelatedControls = (state: RootState) =>
  state.security.lateRateForRelatedControls
export const selectRelatedControlsCosts = (state: RootState) =>
  state.security.relatedControlsCosts
export const selectInProgressActionsForRelatedControls = (state: RootState) =>
  state.security.inProgressActions
export const selectRelatedControlsTree = (state: RootState) =>
  state.security.relatedControlsTree
export const selectRelatedSecurityControls = (state: RootState) =>
  state.security.relatedSecurityControls


// New selectors for count APIs
export const selectCountOtherActionsForSecurityControl = (
  state: RootState
): CountOtherActionsForSecurityControlResponse | null =>
  state.security.countOtherActionsForSecurityControl

export const selectCountOtherActionsForRelatedControls = (
  state: RootState
): CountOtherActionsForRelatedControlsResponse | null =>
  state.security.countOtherActionsForRelatedControls

export const selectCountInProgressActionsForSecurityControl = (
  state: RootState
): CountInProgressActionsForSecurityControlResponse | null =>
  state.security.countInProgressActionsForSecurityControl

export const selectCountDoneActionsForSecurityControl = (
  state: RootState
): CountDoneActionsForSecurityControlResponse | null =>
  state.security.countDoneActionsForSecurityControl

export const selectCountDoneActionsForRelatedControls = (
  state: RootState
): CountDoneActionsForRelatedControlsResponse | null =>
  state.security.countDoneActionsForRelatedControls

// Combined selector for easier access to all count data
export const selectCountData = (state: RootState) => ({
  countOtherActionsForSecurityControl:
    state.security.countOtherActionsForSecurityControl,
  countOtherActionsForRelatedControls:
    state.security.countOtherActionsForRelatedControls,
  countInProgressActionsForSecurityControl:
    state.security.countInProgressActionsForSecurityControl,
  countDoneActionsForSecurityControl:
    state.security.countDoneActionsForSecurityControl,
  countDoneActionsForRelatedControls:
    state.security.countDoneActionsForRelatedControls,
  loading: state.security.loading,
  error: state.security.error,
})
